import emailValidatorUtil from 'modules/redux/validators/email'
import passwordValidatorUtil from 'modules/redux/validators/password'

const KEY_TO_GENERIC_VALIDATOR = {
  email: emailValidatorUtil,
  password: passwordValidatorUtil
}

const CLASS_NAME_TO_VALIDATOR = {}

function validatorUtil (params) {
  const { key, className } = params
  const validator = CLASS_NAME_TO_VALIDATOR[className]
  if (validator && validator[key]) {
    return validator[key]
  }
  return KEY_TO_GENERIC_VALIDATOR[key]
}

export default validatorUtil
